import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-icon_back",
  "use": "icon-icon_back-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-icon_back\"><defs><style></style></defs><path d=\"M921.6 486.4H163.84l286.72-286.72a25.6 25.6 0 1 0-36.25-36.25L84.378 493.978a25.6 25.6 0 0 0 0 36.25l330.956 330.956a25.6 25.6 0 1 0 36.25-36.25l-286.72-286.72H921.6a25.6 25.6 0 0 0 0-51.2z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol